import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { supabase } from '../supabaseClient';

// Landing page for the unsubscribe link in cart-reminder emails. One click,
// no login, no confirm step: the link itself is the request.
export default function UnsubscribePage() {
  const [params] = useSearchParams();
  const token = params.get('t');
  const [state, setState] = useState(token ? 'working' : 'invalid');

  useEffect(() => {
    if (!token) return;
    supabase.rpc('sv_cart_unsubscribe', { p_token: token }).then(
      ({ data, error }) => setState(!error && data ? 'done' : 'invalid'),
      () => setState('invalid'),
    );
  }, [token]);

  return (
    <div className="sv-container sv-page-top sv-page-bottom" style={{ maxWidth: 560, textAlign: 'center' }}>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 900, marginBottom: 12 }}>
        {state === 'working' && 'Unsubscribing…'}
        {state === 'done' && "You're unsubscribed"}
        {state === 'invalid' && "That link didn't work"}
      </h1>
      <p style={{ color: 'var(--text-muted)', marginBottom: 20 }}>
        {state === 'done' && "No more cart reminders. Order emails like receipts and tracking still come through."}
        {state === 'invalid' && 'It may be incomplete. DM us @trainercenter.pokemon and we will take you off the list.'}
      </p>
      <Link to="/shop" className="sv-btn" style={{ display: 'inline-flex' }}>Back to the vault</Link>
    </div>
  );
}
